import type { TTranslationKeys } from '@config/i18n';
import ErrorCodes from '@conversed/shared/src/errors/error-codes';

export const ERROR_TRANSLATION_MAP: Record<string, TTranslationKeys> = {
  [ErrorCodes.INVALID_FILE_CONTENT]: 'errors.invalid-file-content',
  [ErrorCodes.INVALID_FILE_CONTENT_EMPTY]: 'errors.invalid-file-content-empty',
  [ErrorCodes.CONFLICT]: 'errors.conflict',
  [ErrorCodes.ALREADY_EXISTS]: 'errors.already-exists',
  [ErrorCodes.INVALID_REQUEST_BODY]: 'errors.invalid-request-body',
  [ErrorCodes.AUTHORIZATION_ERROR]: 'errors.authorization-error',
  [ErrorCodes.FORBIDDEN]: 'errors.forbidden',
  [ErrorCodes.UNKNOWN_ERROR]: 'errors.unknown-error',
  [ErrorCodes.INTERNAL_SERVER_ERROR]: 'errors.internal-server-error',
};

export const getErrorTranslationKey = (errorCode: string): string => {
  return ERROR_TRANSLATION_MAP[errorCode] || 'errors.unknown-error';
};
